import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import EmployeeSearch from '../../../common/EmployeeSearch';
import { EmployeeAvatar } from '../../../common/EmployeeAvatar';

const SelectEmployee = ({ selectedEmployee, onSelect }) => {
  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h6" gutterBottom>
        Select Individual
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Choose the individual for whom you want to create a development plan.
      </Typography>

      <Box sx={{ maxWidth: 500 }}>
        <EmployeeSearch
          value={selectedEmployee}
          onChange={onSelect}
          label="Search for an individual"
          width={500}
        />
      </Box>

      {selectedEmployee && (
        <Paper
          elevation={0}
          sx={{
            mt: 3,
            p: 2,
            backgroundColor: '#f0f9ff',
            border: '1px solid #bae6fd',
            borderRadius: 2,
            display: 'flex',
            alignItems: 'center',
            gap: 2
          }}
        >
          <EmployeeAvatar employee={selectedEmployee} size={48} />
          <Box>
            <Typography variant="subtitle1" fontWeight={600}>
              {selectedEmployee.fullName}
            </Typography>
            {(selectedEmployee.position?.label || selectedEmployee.grade?.label) && (
              <Typography variant="body2" color="text.secondary">
                {[selectedEmployee.position?.label, selectedEmployee.grade?.label].filter(Boolean).join(' • ')}
              </Typography>
            )}
            {selectedEmployee.email && (
              <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.8rem' }}>
                {selectedEmployee.email}
              </Typography>
            )}
          </Box>
        </Paper>
      )}
    </Box>
  );
};

export default SelectEmployee;
